export const getTypeProject = (type) => {
  switch (type) {
    case "SOLARY_ENERGY":
      return "Energia Solar";
    case "PMUC":
      return "PMUC";
    case "AIR_SUBSTATION":
      return "Subestação Aérea";
    case "VEHICLE_CHARGERS":
      return "Carregadores Veiculares";
    case "SPDA":
      return "SPDA (Para-raios)";
    case "FIRE_FIGHTING_PROJECT":
      return "Projeto de Combate a Incêndio";
    case "PROTECTION_COORDINATION_SELECTIVITY":
      return "Seletividade e Coordenação de Proteção";
    case "ELETRIFICATION_OF_SUBDIVISION":
      return "Eletrificação de Loteamento";
    case "INDUSTRIAL_ELECTRICAL_INSTALLATIONS":
      return "Instalações Elétricas Industriais";
    case "RESIDENTIAL_COMMERCIAL_ELECTRICAL_INSTALLATIONS":
      return "Instalações Elétricas Prediais/Comerciais";
    case "SPDA_REPORT":
      return "Laudo de SPDA";
    case "ADEQUACY_ELECTRICAL_INSTALLATIONS_REPORT":
      return "Laudo de Adequação de Instalações";
    case "GROUNDING_REPORT":
      return "Laudo de Aterramento";
    case "PUBLIC_LIGHTING":
      return "Iluminação Pública";
    case "ICMS_REPORT":
      return "Laudo para Restituição de ICMS";
    default:
      return "Energia Solar";
  }
};